module.exports = __webpack_public_path__ + "static/images/vip-start-title-1.png?v=cf4c545";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/images/vip-start-title-1.png
// module id = H4F4
// module chunks = 1